import { AxiosPromise } from 'axios';
import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceTestTypes } from 'src/types';
import { fileHelper, urlHelper } from '../../helpers';

export const lookupTestTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: serviceTestTypes.TestLookupDataType): AxiosPromise<serviceTestTypes.TestTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.test.lookupTest), {
    blockSpinner,
  });
};

export const lookupTestWithEvent = ({
  limit,
  offset,
  ids,
  value,
  order,
  eventIds,
  sortOrder,
  blockSpinner,
}: serviceTestTypes.TestLookupDataType): AxiosPromise<serviceTestTypes.TestTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  if (eventIds) {
    return axios.get(`${urlsConfig.test.lookupTest}?eventIds=${eventIds}`, {
      blockErrorHandler: true,
    });
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.test.lookupTest), {
    blockSpinner,
  });
};

export const lookupTestOfOntology = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceTestTypes.TestLookupDataType): AxiosPromise<serviceTestTypes.TestOfOntologyLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.test.lookupTestOfOntology), {
    blockSpinner,
  });
};

export const createTest = (
  form: serviceTestTypes.TestCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceTestTypes.TestCreateResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const processesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.taskNumberId) {
    formData.append('taskNumberId', form.taskNumberId);
  }

  if (form.deliverableNumberId) {
    formData.append('deliverableNumberId', form.deliverableNumberId);
  }

  if (form.testNumber) {
    formData.append('testNumber', form.testNumber);
  }

  if (form.testName) {
    formData.append('testName', form.testName);
  }

  if (form.relatedAudienceEntities) {
    form.relatedAudienceEntities.forEach((e) => formData.append('relatedAudienceEntities', e as any as string));

    // formData.append('relatedAudienceEntities', entitiesData);
  }
  if (form.relatedAudienceProcesses) {
    form.relatedAudienceProcesses.forEach((e) => formData.append('relatedAudienceProcesses', e as any as string));

    // formData.append('relatedAudienceEntities', entitiesData);
  }
  // if (form.relatedAudienceProcesses) {
  //   formData.append('relatedAudienceProcesses', processesData);
  // }

  if (form.testerId) {
    formData.append('testerId', form.testerId);
  }

  if (form.description) {
    formData.append('description', form.description);
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.weightOfTestInDeliverable) {
    formData.append('weightOfTestInDeliverable', form.weightOfTestInDeliverable.toString());
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.test) {
    formData.append('test', form.test);
  }

  if (form.testStatusId) {
    formData.append('testStatusId', form.testStatusId);
  }
  return axios.post(urlsConfig.test.createTest, formData, { blockErrorHandler: true });
};

export const testEdit = (
  form: serviceTestTypes.TestEditDataType,
  // formData: FormData,
): AxiosPromise<serviceTestTypes.TestEditResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const processesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.taskNumberId) {
    formData.append('taskNumberId', form.taskNumberId);
  }

  if (form.deliverableNumberId) {
    formData.append('deliverableNumberId', form.deliverableNumberId);
  }

  if (form.testNumber) {
    formData.append('testNumber', form.testNumber);
  }

  if (form.testName) {
    formData.append('testName', form.testName);
  }

  if (form.relatedAudienceEntities) {
    form.relatedAudienceEntities.forEach((e) => formData.append('relatedAudienceEntities', e as any as string));
    // formData.append('relatedAudienceEntities', entitiesData);
  }

  if (form.relatedAudienceProcesses) {
    form.relatedAudienceProcesses.forEach((e) => formData.append('relatedAudienceProcesses', e as any as string));

    // formData.append('relatedAudienceProcesses', processesData);
  }

  if (form.testerId) {
    formData.append('testerId', form.testerId);
  }

  if (form.description) {
    formData.append('description', form.description);
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.weightOfTestInDeliverable) {
    formData.append('weightOfTestInDeliverable', form.weightOfTestInDeliverable.toString());
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.test) {
    formData.append('test', form.test);
  } else {
    formData.append('test', '');
  }

  if (form.testStatusId) {
    formData.append('testStatusId', form.testStatusId);
  }

  return axios.patch(urlsConfig.test.testEdit, formData, { blockErrorHandler: true });
};

export const testDelete = (id: string): AxiosPromise<serviceTestTypes.TestDeleteResultType> => {
  return axios.delete(`${urlsConfig.test.testDelete}/${id}`);
};
